// dependencies
import * as React from "react";

import { cn } from "../../../lib/utils";

// components
import { Badge, BadgeProps, DEFAULT_BADGE_SIZE } from "../Badge";

export interface BadgeNumericProps extends Omit<BadgeProps, "children"> {
	/**
	 * The count to display in the badge
	 */
	count: number;
	/**
	 * The maximum count to display before showing overflow indicator (e.g., +999)
	 * @default 999
	 */
	overflowCount?: number;
}

/**
 * The BadgeNumeric component is used to display a numeric count.
 * To use it, include it as a child of the component you want to attach it to.
 */
const BadgeNumeric = (props: BadgeNumericProps) => {
	const { count, overflowCount = 999, size, dangerouslySetClassName, ...badgeProps } = props;

	// Determine display text
	const displayText = count > overflowCount ? `+${overflowCount}` : count.toString();

	// Only override typography at default size; smaller sizes use Badge's CVA variant
	const typographyClass =
		!size || size === DEFAULT_BADGE_SIZE
			? count > overflowCount
				? "text-extra-small"
				: "text-caption"
			: undefined;

	return (
		<Badge {...badgeProps} size={size} dangerouslySetClassName={cn(typographyClass, dangerouslySetClassName)}>
			{displayText}
		</Badge>
	);
};

export { BadgeNumeric };
